import { useRefreshMediaRect } from "@/utils/hooks";
import { useMemo } from "react";
export default function Comp({ rectOptions, props }) {
  const { width, left, top } = rectOptions;
  const { banners, singleImageWidth, singleImageHeight, between } = props;
  return (
    <div
      style={{
        width,
        height: singleImageHeight,
        position: "absolute",
        display: "flex",
        overflow: "hidden",
        transform: `translate(${left}px, ${top}px)`,
      }}
    >
      {banners[0]?.activityGroup?.[0]?.map((item, index) => (
        <img
          key={index}
          src={item.imageUrl}
          alt=""
          style={{
            width: singleImageWidth,
            height: singleImageHeight,
            flexShrink: 0,
            marginRight: between,
          }}
        />
      ))}
    </div>
  );
}
